import React, { ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Constants from 'style/constants';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';

import styles from './settings-multi-line-row.module.scss';

type Props = {
  title: string;
  formField: ReactNode;
  viewingValue: ReactNode;
  icon?: ReactNode;
  viewingMode?: ViewingMode;
};

const SettingsMultiLineRow = ({ title, formField, viewingValue, icon, viewingMode }: Readonly<Props>): React.JSX.Element => {
  const isViewing = viewingMode === 'viewing';

  return (
    <Stack direction="column" spacing={1} className={styles.container}>
      <Stack direction="row" spacing={2} alignItems="center">
        {icon && <div className={styles.iconWrapper}>{icon}</div>}
        <div className={styles.header}>
          {isViewing ? (
            <Typography variant="subtitle1" color={Constants.Colors.onSurfaceVariant}>
              {title}
            </Typography>
          ) : (
            <div className={styles.formFieldWrapper}>{formField}</div>
          )}
        </div>
      </Stack>

      {isViewing && (
        <Typography variant="subtitle1" className={styles.viewingContent} color={Constants.Colors.onSurfaceVariant}>
          {viewingValue}
        </Typography>
      )}
    </Stack>
  );
};

export default SettingsMultiLineRow;
